import DefaultUserIcon from "../../assets/SidebarAssets/DefaultUserIcon.svg?url";

export const ImageWithFallback = ({ src, alt, fallback = DefaultUserIcon, className = "" }) => (
  <img
    src={src || fallback}
    alt={alt}
    className={className}
    onError={e => {
      e.target.onerror = null;
      e.target.src = fallback;
    }}
  />
);
